import { OrderPhases } from 'src/app/final-balancer/models/final-balance';
import { GanttTask } from './gantt';

export class MultiTask implements GanttTask {
  id: number;
  start_date: Date;
  end_date: Date;
  text: string;
  progress: number;
  duration: number;
  parent: number;
  userId: number;
  orderId: number;
  class: string = 'child-task';

  constructor(user: any, phase: OrderPhases, orderId: number, parent: number) {
    const startDate = phase.OrdersPhasesTasksRel[0].tsStart;
    const endDate =
      phase.OrdersPhasesTasksRel[phase.OrdersPhasesTasksRel.length - 1].tsEnd;

    this.id = phase.id;
    this.userId = user.id;
    this.orderId = orderId;
    this.text = phase.descPhase ?? phase.freeDescription;
    this.start_date = new Date(Number(startDate) * 1000);
    this.end_date = new Date(Number(endDate) * 1000);
    this.parent = parent;
  }
}
